import { DOWNLOAD_APP_LINK } from '../constants'
import { handleDeeplink } from 'utils'
import { events } from './events'
import { AnalytEventAppDownloadProps } from './types'

const appDownloadDeeplink = ({
  linkOnly = false,
  ...props
}: { linkOnly?: boolean } & AnalytEventAppDownloadProps = {}) => {
  if (!linkOnly) events.appDownload({ ...props })
  handleDeeplink(DOWNLOAD_APP_LINK)
}

export const actions = {
  appDownloadDeeplink,
}
